import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { appStr } from 'src/locales/app_strings';
import { Box, ListItem, Typography } from '@mui/material';
import AvatarTextField from 'src/components/widgets/avatar-textfield';
import PaginatedList from 'src/components/ui/list/paginated-list';
import HeaderCellText from 'src/components/ui/list/header-cell-text';
import ListCellText from 'src/components/ui/list/list-cell-text';

export const ListView = (props) => {
  const {
    dataStore,
    onPageChange = () => {},
    onRowsPerPageChange,
    page = 0,
    rowsPerPage = 0,
    onDetailClicked,
  } = props;

  const { t } = useTranslation();
  
  const renderItem = (item, rowstyle, idx) => (
    <ListItem
      divider={true}
      key={idx}
      sx={rowstyle}
      onClick={() => onDetailClicked(item)}
    >
      <ListCellText flex="0 0 70%" >
        <AvatarTextField avatarSrc={item.avatar} avatarName={item.name} value={item.name} 
          subValue={item.phone} 
          avatarSx={{ color: item.statusColor }} />
      </ListCellText>
      <ListCellText flex="0 0 30%" align='right'>
        <Typography variant="body2" color='primary.main'>
          {item.carAssigned}
        </Typography>
        <Typography variant="body3" sx={{color: 'text.secondary'}}>
          {item.options}
        </Typography>
      </ListCellText>
    </ListItem>
  );

  return (
    <Box sx={{ position: 'relative' }}>
      <PaginatedList
        items={dataStore.items}
        loading={dataStore.loading}
        renderItem={renderItem}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
      >
        <HeaderCellText sx={{ width: '70%' }}>{t(appStr.txt_002)}</HeaderCellText>
        <HeaderCellText sx={{ width: '30%', textAlign: 'right' }}>{t(appStr.txt_067)}</HeaderCellText>
      </PaginatedList>
    </Box>
  );
};

ListView.propTypes = {
  dataStore: PropTypes.object,
  onDeselectAll: PropTypes.func,
  onDeselectOne: PropTypes.func,
  onPageChange: PropTypes.func,
  onRowsPerPageChange: PropTypes.func,
  onSelectAll: PropTypes.func,
  onSelectOne: PropTypes.func,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  selected: PropTypes.array,
};
